import React from 'react';
import Navvbar from './../components/header/Navvbar';
import Header from './../components/header/header';
import Home from '../components/home/home';

function Main() {
  return (
    <div>
      <Header />
      <br />
      <Navvbar />
      <br/>
      <Home />
    </div>
  );
}

export default Main;